import React from 'react'
import { ListSection } from '../common'

const DanceItem = (props) =>{
  return(
    <div className='container rounded-xl sm:rounded-2xl flex justify-center p-4 bg-stone-200 dark:bg-stone-500'>
      <iframe className='container aspect-video rounded-xl sm:rounded-2xl' src={props.dance} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
    </div>
  )
}

export const Dance = (props) => {
  const title = "DANCE"
  const description = "On my free time I used to dance:"
  
  return (
    <ListSection title={title} description={description}>
      <div className='flex flex-col gap-4 xl:gap-10 2xl:gap-16 justify-between mt-2 xl:mt-4 xl:flex-row'>
        {props.dances.map((url) => (<DanceItem key={url} dance={url}/>))}
      </div>
    </ListSection>
  )
}